import Icon from '../components/Icon.vue'

Icon.register({
  boxes: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 288c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16v-192c0-8.8 7.2-16 16-16h80v96l32-21.3 32 21.3v-96h80zM176 224c-8.8 0-16-7.2-16-16v-192c0-8.8 7.2-16 16-16h80v96l32-21.3 32 21.3v-96h80c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16h-224zM240 288c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16v-192c0-8.8 7.2-16 16-16h80v96l32-21.3 32 21.3v-96h80z'
      }
    ]
  }
})
